import { useNullableContext } from '../../../nullableContext';
import { PersistentStorageApiContext } from '../../PersistentStorageApiContext';
import { PersistentStorageApi } from '../../types';

// The cast narrows the accessors to a specific store's key and value types
// (see InceptPersistentStorageApi); the provider value is that same object.
export const usePersistentStorageApi = <T extends PersistentStorageApi>() =>
  useNullableContext(
    PersistentStorageApiContext,
    'usePersistentStorageApi must be used within a PersistentStorageProvider',
  ) as T;
